if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.setAttribute('action', '/cart/add');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        let mainInput = document.querySelector('.mainqtyinput');
        let requestToExecute = mainInput.getAttribute('request-type');
        let qty = mainInput?.value;
        let cartQty = document.querySelector('.variant_innerWrapper input[type=radio]:checked+label') ?.getAttribute('variant-cart-quantity');
        let cartTotal = parseInt(document.querySelector('[data-totalprice]')?.getAttribute('data-totalprice'));
        let priceVariable = document.querySelector('.variant_innerWrapper input[type=radio]:checked+label')?.getAttribute('variant-price-atc');
        let productPrice;
        priceVariable === undefined ? (productPrice = 0) : (productPrice = parseInt(priceVariable));
        let totalPrice = cartTotal + productPrice * qty;
        let currentTotal = cartTotal - productPrice * cartQty;
        let newTotal = currentTotal + productPrice * qty;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (totalPrice <= 49999) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        const newError = document.querySelector('.newErrorMessage');
        const newErorrWrapper = document.querySelector('.newErrorWrapper');

        let quantityInput = document.querySelector('.mainqtyinput');
        let variantSelectedToUpdate = quantityInput?.getAttribute('selected-variant-id');
        let variantCount = quantityInput ? Number(quantityInput.getAttribute('data-variant-count')) : 0;
        if (requestToExecute == 'add') {
          if (totalPrice <= 49999) {
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                let errorDescription;
                if (response && !response.status) {
                  checkCartAtt();
                  if (typeof addToCartGTMEvent != 'undefined') {
                    requestIdleCallback(() => {
                      addToCartGTMEvent(response, window.productGTMData, 'pdp'); //GTM Event for ATC
                    });
                  }

                  const isNitroActive = sessionStorage.getItem("nitrox") === "nitro";
                  if (isNitroActive && typeof fetchCart === "function") {
                    fetchCart('nitroUpdatingCart');
                  }
                }
                if(response && response.errors === 'Cart Error') {
                  errorDescription = 'Please select a size';
                  newError.innerText = errorDescription;
                  newErorrWrapper.classList.remove('hidden');
                  if (screen.width < 769) {
                    const errorEle = document.querySelector('.mainProductColorVariants');
                    errorEle.scrollIntoView();
                  }
                }
                if (response.status) {
                  if (screen.width < 769) {
                    const errorEle = document.querySelector('.mainProductColorVariants');
                    errorEle.scrollIntoView();
                  }
                  let allItmes = document.querySelectorAll('.cart-item');
                  if (allItmes.length == 0) {
                    setTimeout(() => {
                      this.cart.classList.add('is-empty');
                    }, '500');
                  }
                  if (response.status == 422) {
                    if (!variantSelectedToUpdate && variantCount > 1) {
                      errorDescription = 'Please select a size';
                    }
                  } else if (response.status == 'bad_request') {
                    errorDescription = 'Please select a size';
                  } else {
                    errorDescription = response.status;
                  }
                  newError.innerText = errorDescription;
                  newErorrWrapper.classList.remove('hidden');
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(errorDescription);
                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  // dummyBtn.setAttribute("aria-disabled", true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                        // this.cart.renderContents(response);
                        if (typeof updateCart === 'function') {
                          updateCart();
                        }
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  // this.cart.renderContents(response);
                  if (typeof updateCart === 'function') {
                    updateCart();
                  }
                }
                updateAddedVarinats(response);
                if (typeof quantityInput === 'object') {
                  quantityInput.validateQtyRulesOnVariantChange(parseInt(variantsArr.find((variant) => parseInt(variant.id) === response.variant_id).inventoryQty));
                }
                productAddedMsg();
                mainFormBtn.innerText = 'ADDED';
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) {
                  this.submitButton.removeAttribute('aria-disabled');
                  // dummyBtn.removeAttribute("aria-disabled");
                }
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                if (screen.width > 768) {
                  setTimeout(() => {
                    showCartRecommendations();
                  }, 500);
                }
              });
            let variantSelected = document.querySelector('.variant_innerWrapper input[type=radio]:checked+label');
            if (variantSelected) {
              let modifyMsg = document.querySelector('.qty-tooltip');
              modifyMsg.style.visibility = 'visible';

              setTimeout(() => {
                modifyMsg.textContent = 'Modify the counter to update quantity';
              }, 2500);

              setTimeout(() => {
                modifyMsg.style.visibility = 'hidden';
                modifyMsg.textContent = 'Product has been added to the cart';
              }, 4500);
            }
          } else {
            orderValueExceededMsg();
          }
        } else if (requestToExecute == 'change') {
          if (newTotal <= 49999) {
            fetch(`${routes.cart_change_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response && !response.status) {
                  checkCartAtt();
                }
                if (response.status) {
                  let errorDescription;
                  if (screen.width < 769) {
                    const errorEle = document.querySelector('.mainProductColorVariants');
                    errorEle.scrollIntoView();
                  }
                  let allItmes = document.querySelectorAll('.cart-item');
                  if (allItmes.length == 0) {
                    setTimeout(() => {
                      this.cart.classList.add('is-empty');
                    }, '500');
                  }
                  if (response.status == 422) {
                    errorDescription = 'The Maximum available quantity is already in you cart';
                  } else if (response.status == 'bad_request') {
                    errorDescription = 'Please select a size';
                  } else {
                    errorDescription = response.status;
                  }
                  newError.innerText = errorDescription;
                  newErorrWrapper.classList.remove('hidden');
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(errorDescription);
                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  // dummyBtn.setAttribute("aria-disabled", true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                        // this.cart.renderContents(response);
                        if (typeof updateCart === 'function') {
                          updateCart();
                        }
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  // this.cart.renderContents(response);
                  if (typeof updateCart === 'function') {
                    updateCart();
                  }
                }
                updateChangedVarinats(response);
                if (window.innerWidth <= 985) {
                  // let mobileUpdateModal = document.querySelector('[data-id="mobile-qty-overlay"]');
                  // if(mobileUpdateModal.classList.contains('show-mobile-qty-overlay')) mobileUpdateModal.classList.remove('show-mobile-qty-overlay');
                  // document.body.style.removeProperty('overflow');
                }
                mainFormBtn.innerText = 'ADDED';
                productUpdatedMsg();
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) {
                  this.submitButton.removeAttribute('aria-disabled');
                  // dummyBtn.removeAttribute("aria-disabled");
                }
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                if (screen.width > 768) {
                  setTimeout(() => {
                    showCartRecommendations();
                  }, 500);
                }
              });
          } else {
            orderValueExceededMsg();
          }
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response && !response.status) {
                checkCartAtt();
              }
              if (response.status) {
                let errorDescription;
                if (screen.width < 769) {
                  const errorEle = document.querySelector('.mainProductColorVariants');
                  errorEle.scrollIntoView();
                }
                let allItmes = document.querySelectorAll('.cart-item');
                if (allItmes.length == 0) {
                  setTimeout(() => {
                    this.cart.classList.add('is-empty');
                  }, '500');
                }
                if (response.status == 422) {
                  errorDescription = 'The Maximum available quantity is already in you cart';
                } else if (response.status == 'bad_request') {
                  errorDescription = 'Please select a size';
                } else {
                  errorDescription = response.status;
                }
                newError.innerText = errorDescription;
                newErorrWrapper.classList.remove('hidden');
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.description,
                  message: response.message,
                });
                this.handleErrorMessage(errorDescription);
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                // dummyBtn.setAttribute("aria-disabled", true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
              if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                      // this.cart.renderContents(response);
                      if (typeof updateCart === 'function') {
                        updateCart();
                      }
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                // this.cart.renderContents(response);
                if (typeof updateCart === 'function') {
                  updateCart();
                }
              }
              updateAddedVarinats(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) {
                this.submitButton.removeAttribute('aria-disabled');
                // dummyBtn.removeAttribute("aria-disabled");
              }
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
              if (screen.width > 768) {
                setTimeout(() => {
                  showCartRecommendations();
                }, 500);
              }
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// function checkCartAtt() {
//   let checkingButton = document.querySelector('.mainNoclick');
//   if (checkingButton?.hasAttribute('data-discountpercentage') && checkingButton?.hasAttribute('data-customerbalance')) {
//     if (!checkingButton?.hasAttribute('data-attribute')) {
//       addCartAttSingle();
//     }
//   }
// }
// function addCartAttSingle() {
//   let gettingAttri = document.querySelector('.mainNoclick');
//   let custBalance = gettingAttri.getAttribute('data-customerbalance');
//   let custDisPercentage = gettingAttri.getAttribute('data-discountpercentage');
//   const draftOrderAtt = {
//     attributes: {
//       customerBalance: custBalance,
//       customerDiscount: custDisPercentage,
//     },
//   };
//   const requestmethod = {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(draftOrderAtt),
//   };
//   const res = fetch('/cart/update.js', requestmethod);
// }
